import { useEffect, useState } from 'react';
export var useProgressiveImage = function (src) {
    var _a = useState(null), sourceLoaded = _a[0], setSourceLoaded = _a[1];
    useEffect(function () {
        var img = new Image();
        img.src = src;
        img.onload = function () { return setSourceLoaded(src); };
    }, [src]);
    return sourceLoaded;
};
